import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { PaletteDb } from '../redux/paletteDbSlice';

const useAllPaletteDbs = (userId: string | undefined): [string[], PaletteDb[]] => {
  const paletteDb = useSelector((state: RootState) => state.paletteDb);
  const rupDb = useSelector((state: RootState) => state.relationUserPaletteDb);
  const rupIds = Object.keys(rupDb.relationUserPalettes).filter(id => rupDb.relationUserPalettes[id].userId === userId);
  rupIds.sort((a, b) => {
    const rupIdA = rupDb.relationUserPalettes[a];
    const rupIdB = rupDb.relationUserPalettes[b];
    return rupIdA.order - rupIdB.order;
  })
  const ids = rupIds.map(id => rupDb.relationUserPalettes[id].paletteId);
  const palettes = ids.map(id => paletteDb.palettes[id]);

  return [ids, palettes];
}

export default useAllPaletteDbs;
